import { useState } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { SCUINoRecordComponent } from '../../../atomic/atoms';
import lostCargoSvg from '../../../assets/icons/svg/pageIcons/lostCargoSearch.svg';
import { SCUITextFieldWithSelectBox } from '../../../atomic/molecules';
import Swal from 'sweetalert2';
import { LCSR } from '../lostCargoSearchReturnPage.classes';

function LostCargoSearchForm() {
    const { t } = useTranslation();
    const history = useHistory();
    const [shippingListNo, setShippingListNo] = useState('');
    const [searchType, setSearchType] = useState(1);

    const searchOptions = [{ value: 1, text: t('lostCargoReturnPageBuilder.shippingListNo') }];

    const handleSearch = () => {
        if (
            shippingListNo !== null &&
            shippingListNo !== undefined &&
            shippingListNo !== '' &&
            shippingListNo.trim() !== '' &&
            !shippingListNo.trim().startsWith('5')
        ) {
            Swal.fire({
                title: t('general.warning'),
                text: t('lostCargoReturnPageBuilder.pleaseEnterShippingNo'),
                icon: 'error',
                timer: 2000,
                showConfirmButton: true,
            });
            return;
        }
        if (shippingListNo.trim()) {
            history.push(`/lost-cargo-return-page?shippingListNo=${shippingListNo.trim()}`);
        }
    };

    return (
        <Box className={LCSR.searchFormRoot}>
            <div
                className={LCSR.searchFormContentWrap}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignContent: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <SCUINoRecordComponent img={lostCargoSvg} />
                <div className={LCSR.searchFormCompositeWrap} style={{ marginTop: '2rem' }}>
                    <SCUITextFieldWithSelectBox
                        className={LCSR.searchFormComposite}
                        selectClassName={LCSR.searchFormSelectType}
                        inputClassName={LCSR.searchFormTextQuery}
                        buttonClassName={LCSR.searchFormButtonSearch}
                        placeholder={t('productSearch.search.placeholder')}
                        buttonText={t('general.search')}
                        value={shippingListNo}
                        selectList={searchOptions}
                        onChangeSelect={(event: any) => {
                            setSearchType(event.target.value);
                        }}
                        selectValue={searchType}
                        onChangeTextField={(event: any) => {
                            setShippingListNo(event.target.value);
                        }}
                        onClickButton={handleSearch}
                        onKeyPressTextField={(e: any) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleSearch();
                            }
                        }}
                    />
                </div>
            </div>
        </Box>
    );
}

export default LostCargoSearchForm;
